import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {  useParams } from "react-router";
import Loading from "../helper/Loading";
import PageHeader from "../helper/PageHeader";
import SimpleTable from "../helper/SimpleTable";

const tableCells = [
    { id: 'question', label: 'Question', centered: false },
    { id: 'correct', label: 'Correct/Incorrect', centered: false },
    { id: 'STUDENTANSWER', label: 'User Answer', centered: false },
    { id: 'CORRECTANSWER', label: 'Correct Answer', centered: false },
];

// the total questions could be added by passing in the score from the previous page, and dividing the numCorrect by the score

const ViewQuizQuestions = props => {
    const mounted = useRef(true)
    const params = useParams()
   // const history = useHistory()

    const [data, setData] = useState({ loading: true, data: null })


    useEffect(() => {
        async function getData() {
            const res = await axios.get('/api/test/detail/' + params.id)

            const data = res.data.details.map(e => {
                // e.CORRECT = (e.CORRECT === true) ? "Correct" : "Incorrect"
                e.correct = (e.CORRECT === true) ? "✔️" : "❌"

                if (e.STUDENTANSWER === 't') e.STUDENTANSWER = "True"
                else if (e.STUDENTANSWER === 'f') e.STUDENTANSWER = "False"

                if (e.CORRECTANSWER === 't') e.CORRECTANSWER = "True"
                else if (e.CORRECTANSWER === 'f') e.CORRECTANSWER = "False"

                const questionName = e.questionOid
                const firstPart =questionName.substr(questionName.indexOf('w')+1)

                e.questionOid = firstPart

                return e

            })



            console.log(data)

            if (mounted.current) {
                setData({ loading: false, data, })
            }
        }



        getData()
        return () => mounted.current = false
    }, [params.id])


    return (
        <>
            <PageHeader title="Question List" backButton />
            {data.loading ? <Loading /> :
                data.data === null ? <h1>No data found</h1> :
                    data.data.length === 0 ? <h1>Record found but no data</h1> :
                        <>
                            <p>Questions seen: {data.data.length}</p>
                            <p>Questions correct: {data.data.filter(e => e.CORRECT === true).length}</p>
                            <SimpleTable
                                data={data.data}
                                cellKey={"id"}
                                tableCells={tableCells}
                                actions={false}
                            />
                        </>
            }
        </>
    )
}

export default ViewQuizQuestions